/**
 * Language matching for caption display.
 *
 * Lives apart from ./functions.ts on purpose: that module imports
 * react-native-adjacent feature code through ../app/types, which the node
 * jest environment cannot load. Caption language gating needs to be unit
 * testable in isolation, same rationale as ./certifiedMode.ts.
 */
/**
 * Compares an incoming caption language tag against the locally selected
 * caption/translation language using primary-subtag matching, so 'en'
 * matches 'en-US' in either direction.
 *
 * An absent selection matches everything (no filter is active). An absent
 * incoming tag also passes: dropping a caption over malformed metadata
 * silently hides speech, which is worse than showing it unfiltered.
 *
 * @param {string | null | undefined} incoming - Language tag carried by the
 * transcription result.
 * @param {string | null | undefined} selected - Locally selected caption
 * language, if any.
 * @returns {boolean} - True when the result should be displayed.
 */
export function isCaptionLanguageMatch(incoming, selected) {
    const incomingPrimary = incoming?.trim().split('-')[0].toLowerCase();
    const selectedPrimary = selected?.trim().split('-')[0].toLowerCase();
    if (!selectedPrimary || !incomingPrimary) {
        return true;
    }
    return incomingPrimary === selectedPrimary;
}
